export default __webpack_public_path__ + "static/media/blog-bg.2759dbbe.png";